/**
 * WiseBadge – badge na bazie MUI Chip z wariantami: favourite, active, blocked
 */

import React, { FC } from 'react';
import { Chip } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { Star, HeartPulse, DashCircle } from 'react-bootstrap-icons';
import { useAppTheme } from 'theme/useAppTheme';
import type { ThemeWithApp } from 'theme/useAppTheme';

export type WiseBadgeVariant = 'favourite' | 'active' | 'blocked';

interface IWiseBadgeProps {
  variant: WiseBadgeVariant;
  size?: 'small' | 'medium';
  className?: string;
}

const getVariantConfig = (theme: ThemeWithApp) => ({
  favourite: {
    backgroundColor: theme.palette.app.badgeWarning,
    icon: Star,
    labelKey: 'Top'
  },
  active: {
    backgroundColor: theme.palette.app.badgeSuccess,
    icon: HeartPulse,
    labelKey: 'Aktywny'
  },
  blocked: {
    backgroundColor: theme.palette.app.badgeError,
    icon: DashCircle,
    labelKey: 'Zablokowane'
  }
} as const);

const WiseBadge: FC<IWiseBadgeProps> = ({ variant, size = 'small', className }) => {
  const { t } = useTranslation();
  const theme = useAppTheme();
  const config = getVariantConfig(theme)[variant];
  const Icon = config.icon;

  return (
    <Chip
      icon={<Icon size={14} color="currentColor" />}
      label={t(config.labelKey)}
      size={size}
      className={className}
      sx={{
        backgroundColor: config.backgroundColor,
        padding: 1,
        color: theme.palette.common.white,
        fontWeight: 600,
        '& .MuiChip-icon': {
          color: theme.palette.common.white,
          marginRight: 0.25
        },
      }}
    />
  );
};

export default WiseBadge;
